import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { deleteTest, savePublicTest } from '../../common/tests/actions'
import Button from '../components/Button'
import EmptyList from '../components/EmptyList'

class TestsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      savedTests: [],
    }
  }

  saveTest(testId) {
    this.setState({
      savedTests: [...this.state.savedTests, testId],
    })
    this.props.savePublicTest(testId)
  }

  render() {
    const { tests, deleteTest, publicTests, intl } = this.props
    const { savedTests } = this.state

    return (
      <div className="tests-list">
        {
          tests.length ?
            tests.map(t => (
              <div className="item-box" key={t.id}>
                <div className="test-info">
                  <h3><Link to={`/app/test/${t.id}`}>{t.name}</Link></h3>
                  <p>
                    {intl.formatMessage(messages.testAddress)}:&nbsp;
                    <Link target="_blank" to={`/test/${t.testId}`}><b>vobo.io/test/{t.testId}</b></Link>
                  </p>
                  {/*
                    t.newResults &&
                    <p>
                      <Link to={`/app/results/${t.id}`}>
                        Nové výsledky
                      </Link>
                    </p>
                  */}
                </div>
                <div className="float-right">
                  {/*
                  <Link to={`/app/test/${t.id}`}>
                    <Button positive>{intl.formatMessage(messages.show)}</Button>
                  </Link>
                  */}
                  {
                    publicTests ?
                      <Button
                        onClick={() => this.saveTest(t.id)}
                        disabled={savedTests.includes(t.id)}
                      >
                        {intl.formatMessage(messages.save)}
                      </Button>
                    :
                      <div className="float-right">
                        <Link to={`/app/results/${t.id}`}>
                          <Button positive icon="percent">
                            {intl.formatMessage(messages.results)}
                          </Button>
                        </Link>
                        <Link to={`/app/edit-test/${t.id}`}>
                          <Button icon="edit">
                            {intl.formatMessage(messages.edit)}
                          </Button>
                        </Link>
                        <Button
                          icon="trash"
                          negative
                          className="disable-spacing-right"
                          onClick={() => deleteTest(t.id)}
                        >
                          {intl.formatMessage(messages.delete)}
                        </Button>
                      </div>
                  }
                </div>
              </div>
            ))
          :
            <EmptyList
              title={intl.formatMessage(messages.noTests)}
              text={intl.formatMessage(messages.testsDescription)}
            />
        }
      </div>
    )
  }
}

TestsList.defaultProps = {
  publicTests: false,
  tests: [],
}

TestsList.propTypes = {
  tests: PropTypes.array,
  publicTests: PropTypes.bool,
  savePublicTest: PropTypes.func.isRequired,
  deleteTest: PropTypes.func.isRequired,
}

const enhance = compose(
  connect((state) => ({
    viewer: state.users.viewer,
  }),
  { deleteTest, savePublicTest }),
  injectIntl,
)

export default enhance(TestsList)

const messages = defineMessages({
  testAddress: {
    id: 'tests.list.testAddress',
    defaultMessage: 'Adresa testu',
  },
  show: {
    id: 'tests.list.show',
    defaultMessage: 'Zobraziť',
  },
  edit: {
    id: 'tests.list.edit',
    defaultMessage: 'Upraviť',
  },
  save: {
    id: 'tests.list.save',
    defaultMessage: 'Uložiť',
  },
  delete: {
    id: 'tests.list.delete',
    defaultMessage: 'Vymazať',
  },
  results: {
    id: 'tests.list.results',
    defaultMessage: 'Výsledky',
  },
  noTests: {
    id: 'tests.list.noTests',
    defaultMessage: 'Zatiaľ žiadne testy',
  },
  testsDescription: {
    id: 'tests.list.testsDescription',
    defaultMessage: 'Testy sú zložené z uložených cvičení. Pri každom teste sa zobrazia výsledky s odpoveďmi žiakov a ich bodovým hodnotením.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/TestsList.js